import { TOPICS_ITEMS, CAROUSEL_ITEMS, RANKING_ITEMS, COMMENTS_ITEMS, CARDS_ITEMS } from '@/mocks/home';

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门标签
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8">
          探索当前最受关注的电影话题与类型
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                item.hot
                  ? 'bg-accent-100 text-accent-800 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {item.label}
              {item.hot && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门专题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          深度策划的电影专题内容，发现更多观影灵感
        </p>
        <div className="flex flex-col gap-6">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row bg-background-50 rounded-lg overflow-hidden"
            >
              <div className="md:w-[320px] lg:w-[380px] flex-shrink-0">
                <div className="aspect-[16/10] md:h-full">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-flex self-start px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-[11px] font-medium mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.description}
                </p>
                <a
                  href="#cards"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览专题
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          本周最受欢迎的电影榜单，看看大家都在看什么
        </p>
        <div className="space-y-2">
          {RANKING_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 bg-background-100 hover:bg-background-200 rounded-lg px-5 py-4 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold font-heading ${
                item.rank === 1
                  ? 'bg-accent-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-300 text-accent-900'
                  : item.rank === 3
                  ? 'bg-accent-200 text-accent-800'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.meta}</p>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="text-sm font-heading font-bold text-accent-600">{item.score}</span>
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.trend === 'new' && <span className="text-[10px] text-primary-500 font-medium bg-primary-100 px-1.5 py-0.5 rounded whitespace-nowrap">NEW</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          来自真实影迷的观影反馈与推荐
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {COMMENTS_ITEMS.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                "{item.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-movie-2-line"></i>
                <span>看过 {item.movie}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          编辑团队精心挑选的优质电影内容，不容错过
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS_ITEMS.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-[11px] font-medium mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}